<template>
  <div class="preview_12">
    <div class="animation__wrp">
      <div class="switch-item">
        <div v-if="!fps_t.switch_status_1.is_configured">
          <img v-if="activeFp && activeFp.fpid === 82" src="@/assets/switchon.png" class="circle__wrp" />
          <img v-else src="@/assets/switchoff.png" class="circle__wrp" />
        </div>
        <div v-else>
          <img v-if="fps_t.switch_status_1.sen.value == fps_t.switch_status_1.config.value" src="@/assets/switchon.png" class="circle__wrp" />
          <img v-else src="@/assets/switchoff.png" class="circle__wrp" />
        </div>
      </div>

      <div class="switch-name">{{ fps_t.switch_on_1.is_configured ? fps_t.switch_on_1.sen.sen_name : '--' }}</div>
      <div class="switch-item">
        <div v-if="!fps_t.switch_status_2.is_configured">
          <img v-if="activeFp && activeFp.fpid === 85" src="@/assets/switchon.png" class="circle__wrp" />
          <img v-else src="@/assets/switchoff.png" class="circle__wrp" />
        </div>
        <div v-else>
          <img v-if="fps_t.switch_status_2.sen.value == fps_t.switch_status_2.config.value" src="@/assets/switchon.png" class="circle__wrp" />
          <img v-else src="@/assets/switchoff.png" class="circle__wrp" />
        </div>
      </div>
      <div class="switch-name">{{ fps_t.switch_on_2.is_configured ? fps_t.switch_on_2.sen.sen_name : '--' }}</div>
    </div>

    <!-- 操作区 -->
    <div class="opr__area">
      <!-- 总览 -->
      <div class="opr-button">
        <div class="opr-image">
          <img src="@/assets/sidebar/home-w.svg" class="opr-button-image" />
        </div>
        <div class="button-name">总览</div>
      </div>

      <!-- 告警 -->
      <div class="opr-button">
        <div class="opr-image">
          <img src="@/assets/sidebar/clock.svg" class="opr-button-image" />
        </div>
        <div class="button-name">定时</div>
      </div>

      <!-- 操作 -->
      <div class="opr-button">
        <div class="opr-image">
          <img src="@/assets/sidebar/setting-w.svg" class="opr-button-image" />
        </div>
        <div class="button-name">设置</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Panel12',
  props: ['fps_t'],
  data() {
    return {
      activeFp: { fpid: null }
    }
  },
  methods: {
    getAFp(flag) {
      this.activeFp.fpid = flag
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.preview_12 {
  position: relative;
  width: 390px;
  height: 844px;
  margin: 0 auto;
  background-size: 100% 100%;
  background: linear-gradient(to bottom, #2b2c44, #0c1117);

  /* 背景动画 */
  .animation__wrp {
    position: absolute;
    top: 64px;
    height: calc(100% - 184px);
    width: 375px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .circle__wrp {
    width: 145px;
    height: 145px;
    border-radius: 50%;
    position: relative;
  }
  .switch-item {
    margin-top: 20px;
    transition: all 0.15s;
  }
  .mt-lg {
    margin-top: 20px;
  }

  .switch-name {
    width: 100%;
    min-height: 22px;
    position: relative;
    font-size: 16px;
    text-align: center;
    color: rgba(155, 153, 153, 1);
  }
  /* 操作区 */
  .opr__area {
    position: absolute;
    height: 100px;
    width: 100%;
    bottom: 0px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .opr-button {
    width: 40px;
  }
  .opr-button_active {
    filter: brightness(80%);
  }
  .opr-image {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.15s;
  }
  .opr-button-image {
    width: 24px;
    height: 24px;
    color: #fff;
  }
  .button-name {
    position: relative;
    display: inline-flex;
    width: 100%;
    font-size: 14px;
    pointer-events: none;
    justify-content: center;
    white-space: nowrap;
  }
}
</style>
